import React, { useEffect, useState } from "react";
import moment from "moment";
import { toast } from "react-toastify";
import { AgGridReact } from "ag-grid-react";
import { smstemplates, createsmstemplate } from "../../../services/sms";

/**
 * Communication > SMS Templates. Create the text-SMS templates that the Send
 * SMS screen requires (template choice is mandatory there). Templates are
 * stored in the shared notification_templates table as notification_type=sms.
 */
export default function SmsTemplates() {
    const [name, setName] = useState("");
    const [tempId, setTempId] = useState("");
    const [body, setBody] = useState("");
    const [rows, setRows] = useState([]);
    const [loading, setLoading] = useState(false);
    const [saving, setSaving] = useState(false);

    function listall() {
        setLoading(true);
        smstemplates().then((res) => {
            const list = res?.data?.data || [];
            setRows(list.filter((t) => ["sms", "both"].includes(t.notification_type)));
            setLoading(false);
        });
    }

    useEffect(() => {
        listall();
    }, []);

    function handlesave(e) {
        e.preventDefault();

        if (!name.trim()) {
            toast.error("Enter a template name.");
            return;
        }
        if (!tempId.trim()) {
            toast.error("Enter the DLT template id.");
            return;
        }
        if (!body.trim()) {
            toast.error("Enter the template message.");
            return;
        }

        const payload = {
            template_name: name.trim(),
            // Unique code the backend requires; not shown to the user.
            template_code: "SMS_" + Date.now(),
            notification_type: "sms",
            sms_body: body.trim(),
            temp_id: tempId.trim(),
            trigger_event: "custom",
            is_active: true,
        };

        setSaving(true);
        createsmstemplate(payload)
            .then((res) => {
                // createtemplate wraps its result: data.status is 'success' on ok.
                if (res?.status === true && res?.data?.status === "success") {
                    toast.success("Template created successfully");
                    setName("");
                    setTempId("");
                    setBody("");
                    listall();
                } else {
                    const msg =
                        res?.data?.message ||
                        (res?.data?.errors && Object.values(res.data.errors)[0]?.[0]) ||
                        "Failed to create template";
                    toast.error(msg);
                }
            })
            .finally(() => setSaving(false));
    }

    const columnDefs = [
        {
            headerName: "Template Name",
            field: "template_name",
            width: 220,
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "DLT Template ID",
            field: "temp_id",
            width: 200,
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Message",
            field: "sms_body",
            flex: 1,
            minWidth: 280,
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            tooltipField: "sms_body",
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Created",
            field: "created_at",
            width: 140,
            sortable: true,
            resizable: true,
            cellStyle: { textAlign: "left" },
            valueFormatter: (params) =>
                params.value ? moment(params.value).format("DD-MM-YYYY") : "-",
        },
    ];

    return (
        <div>
            <div className="page-header">
                <h2 className="main-content-title tx-24 mg-b-5">SMS Templates</h2>
                <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                        <a>Communication</a>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                        SMS Templates
                    </li>
                </ol>
            </div>

            <div className="content-body">
                <div className="row">
                    <div className="col-xl-12">
                        <div className="card">
                            <div className="card-header">
                                <h2 className="main-content-title tx-24 mg-b-5">
                                    Add Template
                                </h2>
                            </div>
                            <div className="card-body">
                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="mb-3">
                                            <label className="form-label">
                                                Template Name{" "}
                                                <span className="text-danger">*</span>
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Enter Template Name"
                                                value={name}
                                                onChange={(e) => setName(e.target.value)}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="mb-3">
                                            <label className="form-label">
                                                DLT Template ID{" "}
                                                <span className="text-danger">*</span>
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="e.g. 1707176347745206815"
                                                value={tempId}
                                                onChange={(e) => setTempId(e.target.value)}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-12">
                                        <div className="mb-3">
                                            <label className="form-label">
                                                Message <span className="text-danger">*</span>
                                            </label>
                                            <textarea
                                                className="form-control"
                                                rows="3"
                                                placeholder="Enter Message (must match the approved DLT template)"
                                                value={body}
                                                onChange={(e) => setBody(e.target.value)}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-12 text-end">
                                        <a
                                            type="submit"
                                            className={`btn btn-success ${saving ? "disabled" : ""}`}
                                            onClick={saving ? undefined : handlesave}
                                        >
                                            {saving ? "Saving..." : "Add Template"}
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {loading && (
                    <div className="loader-wrapper">
                        <div className="loader"></div>
                        <h3>Loading...Please do not go back or close the window.</h3>
                    </div>
                )}
                {!loading && (
                    <div className="container">
                        <div className="ag-theme-alpine ag-style mt-2">
                            <AgGridReact
                                columnDefs={columnDefs}
                                rowData={rows}
                                pagination="true"
                                paginationPageSize="10"
                                sortingOrder={["asc", "desc"]}
                                suppressDragLeaveHidesColumns={true}
                            />
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}
